require('./masthead.styl');
new ngDirective('masthead', function masthead() {});